import React, { FC } from 'react';
import { FormCheck } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

export interface Props {
  value: Array<string>;
  options: { text: JSX.Element | string; value: string }[] | undefined;
  onChange: (value: string[]) => void;
  multiSelection: boolean | undefined;
  readOnlyMode?: boolean;
  className?: string;
}

const OptionList: FC<Props> = ({ value, options, onChange, multiSelection, readOnlyMode, className }: Props) => {
  if (multiSelection && options && options.length > 0) {
    return (
      <React.Fragment>
        {options.map((option) => {
          return (
            <FormCheck
              type="checkbox"
              id={`check-${option.value}-${uuidv4()}`}
              onChange={async () => {
                if (value && value.includes(option.value)) {
                  const newValue = value.filter((val) => val !== option.value);
                  await onChange(newValue);
                } else {
                  await onChange((value || []).concat(option.value));
                }
              }}
              checked={value && value.includes(option.value)}
              key={option.value}
              label={option.text}
              disabled={readOnlyMode}
              readOnly={readOnlyMode}
              className={className}
            />
          );
        })}
      </React.Fragment>
    );
  } else if (options && options.length > 0) {
    return (
      <React.Fragment>
        {options.map((option) => {
          const checked = value && option.value === value[0];
          return (
            <FormCheck
              id={`radio-${option.value}-${uuidv4()}`}
              onClick={async () => {
                if (checked) {
                  await onChange([]);
                }
              }}
              onChange={async () => {
                await onChange([option.value]);
              }}
              checked={checked}
              type="radio"
              key={option.value}
              label={option.text}
              disabled={readOnlyMode}
              readOnly={readOnlyMode}
              className={className}
            />
          );
        })}
      </React.Fragment>
    );
  }
  return null;
};

export default OptionList;
